var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "product-rating" }, [
    _c(
      "div",
      { staticClass: "product-rating__mask" },
      _vm._l(_vm.max, function(i) {
        return _c("SVGStarFilled", {
          key: "rating-mask-" + i,
          staticClass: "product-rating__mask-icon"
        })
      }),
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "product-rating__value" },
      [
        _vm._l(_vm.fullStars, function(i) {
          return _c("SVGStarFilled", {
            key: "rating-value-" + i,
            staticClass: "product-rating__value-icon"
          })
        }),
        _vm._v(" "),
        _vm.halfStar
          ? _c("SVGStarFilledHalf", {
              staticClass: "product-rating__value-icon"
            })
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }